const TRANS = [];
window.MISSING_TRANSLATIONS = [];

export default class Translate {
    static simpleMessage(toTranslate) {
        if (TRANS[toTranslate]) {
            return TRANS[toTranslate];
        } else {
            window.MISSING_TRANSLATIONS.indexOf(toTranslate) === -1 && window.MISSING_TRANSLATIONS.push(toTranslate);
            console.error('Message "' + toTranslate + '" not found');
            return 'NotFound';
        }
    };
}
